const BASE_URL = 'https://storage.wewatch.nl';
const TEST_KEY = 'tua_jnk8kqx1wuh4NYE';

class FileService {
    static async uploadFileBrowser(file, meldingId) {
        const formData = new FormData();

        if (!file) {
            throw new Error('File is required for upload');
        }

        // Append the File object directly - no need for uri/path
        formData.append('file', file, file.name);
        formData.append('folder', meldingId);

        try {
            const response = await fetch(`${BASE_URL}/upload`, {
                method: 'POST', // Important: specify POST method
                body: formData, // Pass formData as body, not second parameter
                headers: {
                    'Accept': 'application/json',
                    // Don't set Content-Type - let browser set it with boundary
                    'Authorization': `Bearer ${TEST_KEY}`,
                },
                signal: AbortSignal.timeout(60000), // 60 seconds timeout
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();

            if (data.success) {
                delete data.original_name;
                delete data.success;
                delete data.folder;
            }

            return data;
        } catch (error) {
            console.error('Upload error:', error);
            throw error;
        }
    }

    static async uploadFile(filePath, fileType, meldingId) {

        const formData = new FormData();
        if (!filePath) {
            throw new Error('File path is required for upload');
        }
        formData.append('file', {
            uri: filePath,
            type: fileType,
            name: filePath.split('/').pop(),
        });
        formData.append('folder', meldingId);
        const response = await fetch(`${BASE_URL}/upload`, formData, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${TEST_KEY}`,
            },
            signal: AbortSignal.timeout(60000), // 60 seconds timeout
        });

        if (response.data.success) {
            delete response.data.original_name;
            delete response.data.success;
            delete response.data.folder;
        }

        return response.data;
    }

    static async getAllFiles(meldingId) {
        try {
            console.log('Fetching all files for melding ID:', meldingId);
            const response = await fetch(`${BASE_URL}/folder/${meldingId}/files`, {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${TEST_KEY}`,
                    'X-WeWatch-File-Access-Key': TEST_KEY
                },
            });
            return response.json();
        } catch (error) {
            console.error('Error fetching file URL:', error);
            throw error;
        }
    }

    static async getFileUrl(filename, meldingId) {
        try {
            if (!filename) {
                throw new Error('Filename is required for viewing');
            }
            const response = await fetch(`${BASE_URL}/file/${meldingId}/${filename}`, {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${TEST_KEY}`,
                    'X-WeWatch-File-Access-Key': TEST_KEY
                },
            });

            const blob = await response.blob();
            return URL.createObjectURL(blob);
        } catch (error) {
            console.error('Error fetching file URL:', error);
            throw error;
        }
    }
}

export default FileService;